import React from 'react';
import { styled } from 'linaria/react';
import { CalculationForm } from './form';

export const Calculation = () => (
  <Container>
    <CalculationForm />
  </Container>
);

const Container = styled.div`
  height: 100%;
`;
